import React, { FC } from 'react'
import { Col, Row } from 'antd'
import { SoftwareCard } from './SoftwareCard'
import { usePaymentMethod } from '../hooks'
import { PlanType } from '@pollination-solutions/pollination-sdk'

export const SoftwareList: FC = () => {

  const { softwareProducts } = usePaymentMethod()

  return (
    <Row justify={'center'} align={'middle'} 
    style={{
      textAlign: 'center'
    }}>
      <Col span={18}>
        <Row justify={'center'} align={'middle'} gutter={[16, 16]}>
          {softwareProducts
          ?.filter(s => s.product.plan_type !== PlanType.CloudCompute) 
          ?.map(s =><Col span={24} key={s.price.id}>
            <SoftwareCard productDetails={s} />
          </Col>)}
        </Row>
      </Col>
    </Row>
  )
}
